import React from "react";

import CardRadio from "../cardRadio";
import { CardPlansHeader } from "../cardRadio/styles";
import TextOrStatus from "../textOrStatus";
import WarningBannerAssignature from "../warningBannerAssignature";
import { ContainerMethod, TituloCard } from "./styles";
import { getSignCardStatus } from "./rules";
import { Auxiliar } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";

// Componente único de cards de tipo de assinatura (Manual, Eletrônica, Digital).
// Reaproveitado em todas as telas que exigem seleção de assinatura: Licença
// profissional, cadastro de RT, modal de CREA/Visto/CFTA e emissão de receita.
const SignatureTypeCards = ({
  value,
  onChange,
  allowedSignatures,
  estadoValue,
  hasDigitalCredential,
  hasElectronicCredential,
  onUploadCertificado,
  onCadastrarAssinatura,
  responsavelNome,
  namePrefix = "signature_type",
  disabled,
}) => {
  const statusM = getSignCardStatus("M", allowedSignatures, estadoValue, true);
  const statusE = getSignCardStatus("E", allowedSignatures, estadoValue, hasElectronicCredential);
  const statusD = getSignCardStatus("D", allowedSignatures, estadoValue, hasDigitalCredential);

  const statusByType = { M: statusM, E: statusE, D: statusD };
  const selectedStatus = value ? statusByType[value] : null;

  const selectType = (type) => {
    if (disabled) return;
    if (statusByType[type]?.variant === "disabled") return;
    onChange(type);
  };

  // A assinatura pertence ao responsavel tecnico, nao a licenca: o alerta cita o nome
  // do RT em vez do numero do CREA/Visto/CFTA.
  const responsavelSuffix = responsavelNome ? ` para ${responsavelNome}` : "";

  return (
    <>
      <ContainerMethod>
        <CardRadio
          selected={value === "M"}
          disabled={disabled || statusM.variant === "disabled"}
          onClick={() => selectType("M")}
          id={`${namePrefix}-m`}
          name={namePrefix}
          checked={value === "M"}
          onChange={() => selectType("M")}
        >
          <CardPlansHeader>
            <TituloCard fontWeight={800} color={theme.colors.gray.Cinza_2}>
              Assinatura <br /> Manual
            </TituloCard>
            <Auxiliar color={theme.colors.gray.Cinza_5}>
              Necessário imprimir o Receituário para <b>assinar à próprio punho</b>.
            </Auxiliar>
            <TextOrStatus variant={statusM.variant} text={statusM.text} />
          </CardPlansHeader>
        </CardRadio>

        <CardRadio
          selected={value === "E"}
          disabled={disabled || statusE.variant === "disabled"}
          onClick={() => selectType("E")}
          id={`${namePrefix}-e`}
          name={namePrefix}
          checked={value === "E"}
          onChange={() => selectType("E")}
        >
          <CardPlansHeader>
            <TituloCard fontWeight={800} color={theme.colors.gray.Cinza_2}>
              Assinatura <br /> Eletrônica
            </TituloCard>
            <Auxiliar color={theme.colors.gray.Cinza_5}>
              Conjunto de <b>dados digitais para validação</b>. Não precisa imprimir para assinar.
            </Auxiliar>
            <TextOrStatus variant={statusE.variant} text={statusE.text} />
          </CardPlansHeader>
        </CardRadio>

        <CardRadio
          selected={value === "D"}
          disabled={disabled || statusD.variant === "disabled"}
          onClick={() => selectType("D")}
          id={`${namePrefix}-d`}
          name={namePrefix}
          checked={value === "D"}
          onChange={() => selectType("D")}
        >
          <CardPlansHeader>
            <TituloCard fontWeight={800} color={theme.colors.gray.Cinza_2}>
              Assinatura <br /> Digital
            </TituloCard>
            <Auxiliar color={theme.colors.gray.Cinza_5}>
              Assina com o <b>certificado A1</b> cadastrado no CREA/CFTA do responsável técnico.
            </Auxiliar>
            <TextOrStatus variant={statusD.variant} text={statusD.text} />
          </CardPlansHeader>
        </CardRadio>
      </ContainerMethod>

      {selectedStatus?.variant === "warning" &&
      (value === "D" ? onUploadCertificado : onCadastrarAssinatura) ? (
        <WarningBannerAssignature
          maxWidth="760px"
          boldText={
            value === "D"
              ? `Nenhum certificado A1 cadastrado${responsavelSuffix}.`
              : `Nenhuma assinatura eletrônica cadastrada${responsavelSuffix}.`
          }
          text={
            value === "D"
              ? " Envie o arquivo PFX para emitir com assinatura digital."
              : " Importe uma imagem (.PNG ou .JPG) ou desenhe sua assinatura."
          }
          buttonText={value === "D" ? "Enviar certificado" : "Cadastrar assinatura"}
          onButtonClick={() => {
            if (value === "D") {
              onUploadCertificado?.();
            } else {
              onCadastrarAssinatura?.();
            }
          }}
        />
      ) : null}
    </>
  );
};

export default SignatureTypeCards;
